<template>
  <div>
    <v-btn
      icon
      @click="cartVisible = !cartVisible"
      :loading="cartIsLoading"
      :disabled="!canUserViewPartsAndRepairtimes"
    >
      <v-badge
        :value="defaultCartCounter > 0 && !cartIsLoading"
        :content="defaultCartCounter"
        bottom
        right
        overlap
      >
        <v-icon>$cart</v-icon>
      </v-badge>
    </v-btn>
    <span v-if="defaultCartCounter > 0" id="cartCounter"></span>
    <v-dialog v-model="cartVisible" scrollable width="80%" class="pa-0 ma-0">
      <span id="cartVisibilityPlaceholder" v-if="cartVisible" class="d-none"></span>
      <v-sheet class="px-2">
        <multi-cart
          :is-visible="cartVisible"
          :fixed-height="true"
          class="pa-0 ma-0"
          @close="cartVisible = false"
        ></multi-cart>
      </v-sheet>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MultiCart from "@/components/common/MultiCart";

import RightsMixin from "@/mixins/rights";

export default {
  mixins: [RightsMixin],
  name: "CartButtonComponent",
  components: {
    MultiCart,
  },
  data: () => ({
    cartVisible: false,
  }),
  created() {},
  mounted() {
    this.getCartAndRepairtimes();
  },
  watch: {
    canUserViewPartsAndRepairtimes() {
      this.getCartAndRepairtimes();
    },
  },
  computed: {
    ...mapState("cart", [
      "defaultCartCounter",
      "carts",
      "defaultCartId",
      "cartIsLoading",
    ]),
    url() {
      return process.env.VUE_APP_API_URL;
    },
  },
  methods: {
    getCartAndRepairtimes() {
      if (this.canUserViewPartsAndRepairtimes && this.isHavingTarrifplan) {
        this.$store.dispatch("cart/getCarts");
        if (this.userHasRight("parts_and_repairtimes|view")) {
          this.$store.dispatch("repairtimes/get");
        }
      }
    },
  },
};
</script>